/* istanbul ignore file */
import { Component, Injectable, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
})
@Injectable()
export class DashboardComponent implements AfterViewInit {
  ngAfterViewInit(): void {}
}
